<div mat-dialog-title class="dialog-header">
    <span class="dialog-header-icon"><mat-icon>groups</mat-icon></span>
    <div>
        <h2>Lista de Presença</h2>
    </div>
</div>
<mat-dialog-content>
    <mat-card class="scrollable-list-container">
        <mat-card-content id="canvas">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="search-box">
                <mat-form-field style="width: 300px; padding-top: 10px;">
                    <mat-label>Pesquisa</mat-label>
                    <input matInput placeholder="Pesquise na tabela" (keyup)="applyFilter($event.target.value)">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                <mat-paginator class="paginator" [pageSize]="20" [pageSizeOptions]="[20, 50, 100]"
                    [showFirstLastButtons]="true">
                </mat-paginator>
            </div>

            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Descrição </th>
                    <td mat-cell *matCellDef="let element"> {{ element.associate }} </td>
                </ng-container>

                <ng-container matColumnDef="wasPresent">
                    <th mat-header-cell *matHeaderCellDef> Presente </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon class="{{ element.wasPresent ? 'success-text' : 'danger-text' }}">
                            {{ element.wasPresent ? 'check' : 'close' }}
                        </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row" align="right">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="markAsPresent(row)" *ngIf="!row.wasPresent">
                                <mat-icon>check</mat-icon>
                                <span>Marcar como presente</span>
                            </button>
                            <button mat-menu-item (click)="markAsAbsent(row)" *ngIf="row.wasPresent">
                                <mat-icon>close</mat-icon>
                                <span>Marcar como ausente</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="close()">Fechar</button>
    <button mat-icon-button printSectionId="canvas" [useExistingCss]="true" ngxPrint>
        <mat-icon class="material-icons-outlined">file_download</mat-icon>
    </button>
</mat-dialog-actions>